import {
  InspectorControls,
  useBlockProps,
  useInnerBlocksProps,
  store as blockEditorStore,
} from "@wordpress/block-editor";
import { useEffect } from "@wordpress/element";
import { useDispatch } from "@wordpress/data";
import { useInstanceId } from "@wordpress/compose";

import ProductCollectionInspectorControls from "./InspectorControls";

// Default inner template: a single product-template child that holds the
// per-product card layout authored by the admin.
const TEMPLATE = [["brandy/product-template", {}]];

export default function Edit(props) {
  const { attributes, setAttributes } = props;

  const blockProps = useBlockProps();
  const { __unstableMarkNextChangeAsNotPersistent } =
    useDispatch(blockEditorStore);

  const instanceId = useInstanceId(Edit);

  const innerBlocksProps = useInnerBlocksProps(blockProps, {
    template: TEMPLATE,
    templateLock: false,
  });

  const { queryId } = attributes;

  // Assign a stable queryId once, without polluting the undo history.
  useEffect(() => {
    if (!Number.isFinite(queryId)) {
      __unstableMarkNextChangeAsNotPersistent();
      setAttributes({ queryId: instanceId });
    }
  }, [queryId, instanceId]);

  return (
    <>
      <InspectorControls>
        <ProductCollectionInspectorControls
          attributes={attributes}
          setAttributes={setAttributes}
        />
      </InspectorControls>
      <div {...innerBlocksProps} />
    </>
  );
}
